// 前端配置管理
// 直接从 .env 文件读取配置

const CONFIG = {
  // API基础URL配置
  getApiBaseUrl() {
    // 从环境变量读取API地址，如果没设置则使用默认值
    // 本地开发环境使用 localhost:3002
    return process.env.REACT_APP_API_URL ||
           (process.env.NODE_ENV === 'development' ? 'http://localhost:3002' : 'https://easy-record-web.rongyilin87.workers.dev');
  },

  // 获取当前环境信息
  getEnvironmentInfo() {
    return {
      environment: process.env.NODE_ENV || 'development',
      apiBaseUrl: this.getApiBaseUrl(),
      isProduction: process.env.NODE_ENV === 'production'
    };
  }
};

export default CONFIG;